type DimensionToReturn = 'width' | 'height';

export const getNewDimensionsWithAspectRatio = (
    originalWidth: number,
    originalHeight: number,
    newDimensionValue: number,
    dimensionToReturn: DimensionToReturn
): number => {
    if (dimensionToReturn === 'width') {
        return Math.round((newDimensionValue * originalWidth) / originalHeight);
    }
    return Math.round((newDimensionValue * originalHeight) / originalWidth);
};
